import { Validators } from '@angular/forms';
import { DecimalProvider } from '../../../../../order-builder/modules/specification/providers/decimal.provider';
import { FieldSelectConfig } from '../../../../../shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { FormSelectComponent } from '../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { OneClickBuilderPaymentsEffects } from '../../../../effects/one-click-payment-builder.effects';
import { OneClickRegionPlantsEffects } from '../../../../effects/one-click-region-plants.effects';
import { OneCLickAlternativeUnitsBuilderEffects } from '../../../../effects/one-click-units-builder.effects';
import { OneClickPaymentDisabler } from '../../../../providers/builder/one-click-payment-enabler.provider';
import { OneClickPlantDisabler } from '../../../../providers/builder/one-click-plant-enabler.provider';
import { OneClickProductDisabler } from '../../../../providers/builder/one-click-product-enabler.provider';
import { OneClickUnitDisabler } from '../../../../providers/builder/one-click-unit-enabler.provider';
import { OneClickLoadSalesArea } from '../../../../services/commands/one-click-load-sales-area-command.service';
import { OneClickLoadProductPayments } from '../../../../services/commands/one-click-payments.command.service';
import { OneClickLoadProductPlants } from '../../../../services/commands/one-click-plants.command.service';
import { OneClickSyncPayment } from '../../../../services/commands/one-click-sync-payment.command';
import { OneClickSyncPlant } from '../../../../services/commands/one-click-sync-plants.command.service';
import { OneClickSyncProduct } from '../../../../services/commands/one-click-sync-product.command.service';
import { OneClickSyncQuantity } from '../../../../services/commands/one-click-sync-quantity.command.service';
import { OneClickSyncUnits } from '../../../../services/commands/one-click-sync-units.command.service';
import { OneClickLoadProductUnits } from '../../../../services/commands/one-click-units.command.service';
import { OneClickJobsiteLoaderService } from '../../../../services/loaders/one-click-jobsites.loader.service';
import { OneClickPaymentsLoaderService } from '../../../../services/loaders/one-click-payments.loader.service';
import { OneClickPlantsLoaderService } from '../../../../services/loaders/one-click-plants.loader.service';
import { OneClickProductsLoaderService } from '../../../../services/loaders/one-click-products.loader.service';
import { OneClickUnitsLoaderService } from '../../../../services/loaders/one-click-units.loader.service';
import { OneClickBuilderField } from '../../../../util/constants/builder-fields';
import { FormInputNumberComponent } from './../../../../../shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import { OneClickSyncJobsiteLoadProducts } from './../../../../services/commands/one-click-sync-jobsites.command.service';
import { OneClickQuantityBuilderProvider } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-quantity-enabler.provider';
import { OneClickEditProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-edit.provider';
import { FormGenericItemComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { FieldClassesDeliveryBuilder } from '@ordersnproducts/modules/one-click-order/constants/builder-field-classes.enum';
import { FieldLabelConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-location.provider';
import { OneClickPaymentTermDescProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-paymentdesc.provider';
import { SALES_DOCUMENT_TYPE_ID } from '@ordersnproducts/modules/shared/constants/sales-document-type-id';
import { FieldProductSelectionConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-product-selection-config.interface';

export const jobsite: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickDeliveryMethodProvider.TextBuilder,
    label: 'views.one_click.delivery_method',
    containerClassNames: [FieldClassesDeliveryBuilder.DELIVERY_METHOD_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    name: '',
    type: FormGenericItemComponent,
    text: OneClickLocationProvider.TextBuilder,
    label: 'views.one_click.jobsite',
    containerClassNames: [FieldClassesDeliveryBuilder.LOCATION_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickBuilderField.Jobsite,
    label: 'views.one_click.jobsite',
    containerClassNames: ['col-md-6 mb-3 pushed retail-control text-capitalize'],
    onChange: [OneClickSyncJobsiteLoadProducts, OneClickLoadSalesArea],
    placeholder: 'views.one_click.select_jobsite',
    optionsLoader: OneClickJobsiteLoaderService,
    validation: [Validators.required],
    visible: OneClickEditProvider.VisibleCreate,
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.one_click.product',
    name: OneClickBuilderField.Product,
    containerClassNames: ['col-md-6 mb-3 retail-control text-capitalize'],
    placeholder: 'views.one_click.select_product',
    onChange: [OneClickSyncProduct, OneClickLoadProductPayments, OneClickLoadProductPlants, OneClickLoadProductUnits],
    loading: OneClickProductDisabler,
    optionsLoader: OneClickProductsLoaderService,
    validation: [Validators.required],
    dropdownSalesDocumentTypes: [SALES_DOCUMENT_TYPE_ID.TOP_PRODUCTS],
  } as FieldProductSelectionConfig,
  {
    type: FormInputNumberComponent,
    label: 'views.specifications.quantity',
    name: OneClickBuilderField.Quantity,
    containerClassNames: ['col-md-3 mb-3 retail-control'],
    value: OneClickQuantityBuilderProvider,
    min: 1,
    step: 1,
    max: 99999,
    onChange: [OneClickSyncQuantity],
    decimals: DecimalProvider,
    validation: [Validators.required, Validators.min(1), Validators.max(99999)],
  } as FieldInputNumberConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.unit',
    name: OneClickBuilderField.Unit,
    placeholder: '',
    containerClassNames: ['col-md-3 mb-3 retail-control'],
    onChange: [OneClickSyncUnits],
    dynamicEffects: [OneCLickAlternativeUnitsBuilderEffects],
    loading: OneClickUnitDisabler,
    optionsLoader: OneClickUnitsLoaderService,
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.plant',
    name: OneClickBuilderField.Plant,
    containerClassNames: ['col-md-6 mb-3 retail-control text-capitalize'],
    placeholder: 'views.one_click.select_plant',
    onChange: [OneClickSyncPlant],
    dynamicEffects: [OneClickRegionPlantsEffects],
    loading: OneClickPlantDisabler,
    optionsLoader: OneClickPlantsLoaderService,
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    name: '',
    type: FormGenericItemComponent,
    text: OneClickPaymentTermDescProvider.PaymentBuilder,
    label: 'views.specifications.paymentTerms',
    containerClassNames: ['col-md-6 mb-3 retail-control text-capitalize'],
    hidden: OneClickEditProvider.VisibleCreate,
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.paymentTerms',
    name: OneClickBuilderField.Payment,
    containerClassNames: ['col-md-3 mb-3 retail-control text-capitalize'],
    placeholder: 'views.one_click.select_payment',
    onChange: [OneClickSyncPayment],
    dynamicEffects: [OneClickBuilderPaymentsEffects],
    loading: OneClickPaymentDisabler,
    optionsLoader: OneClickPaymentsLoaderService,
    validation: [Validators.required],
    visible: OneClickEditProvider.VisibleCreate,
  } as FieldSelectConfig,
];
